<div
	class="h-full mt-24px pb-[100px] px-12px custom-filter"
	[formGroup]="filterForm"
>
	<div class="flex justify-between items-center">
		<h1 class="tw-font-bold mb-0 font-semibold text-[24px]">
			{{ 'GENERAL_LABELS.FILTRATION' | translate }}
		</h1>
		<button *ngIf="filterCount" class="flex text-link" (click)="resetFilter()">
			{{ 'ACTIONS.RESET' | translate }}
			<img
				class="align-middle mx-2"
				src="assets/images/icon-reset.svg"
				alt="icon"
			/>
		</button>
	</div>

	<!-- START END DATE  -->
	<div class="mt-24px">
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'GENERAL_LABELS.DATE_RANGES' | translate }}
		</p>
		<div class="w-full">
			<mat-form-field
				class="w-full"
				appearance="outline"
				(click)="datepicker.open()"
			>
				<mat-label>{{ 'GENERAL_LABELS.START_DATE' | translate }}</mat-label>
				<input
					[dir]="translate?.currentLang == 'en' ? 'ltr' : 'rtl'"
					matInput
					[placeholder]="this.getController('startDate')?.value"
					[matDatepicker]="datepicker"
					formControlName="startDate"
					class="text-[#4E4B66]"
				/>
				<img
					*ngIf="getController('startDate')?.value"
					(click)="getController('startDate').reset()"
					class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
					src="./assets/images/close-square.svg"
					alt=""
				/>
				<mat-datepicker #datepicker> </mat-datepicker>
				<mat-error>
					<validation-message
						[controller]="getController('startDate')"
						controller_name="GENERAL_LABELS.START_DATE"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>

			<mat-form-field
				class="w-full"
				appearance="outline"
				(click)="datepickerTo.open()"
			>
				<mat-label>{{ 'GENERAL_LABELS.END_DATE' | translate }}</mat-label>
				<input
					[readonly]="true"
					[dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'"
					matInput
					[matDatepicker]="datepickerTo"
					formControlName="endDate"
					class="text-[#4E4B66]"
				/>
				<img
					*ngIf="getController('endDate')?.value"
					(click)="getController('endDate').reset()"
					class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
					src="./assets/images/close-square.svg"
					alt=""
				/>
				<mat-datepicker #datepickerTo> </mat-datepicker>
				<mat-error>
					<validation-message
						[controller]="getController('endDate')"
						controller_name="GENERAL_LABELS.END_DATE"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
			<mat-error class="mb-[12px]">
				<div
					class="whitespace-nowrap"
					*ngIf="
						getController('endDate').value < getController('startDate').value &&
						getController('endDate').value
					"
				>
					{{ 'VALIDATION.END_DATE_ERROR' | translate }}
				</div>
			</mat-error>
		</div>
		<!-- START END DATE  -->
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<!-- CLIENT USAGE  -->
		<div>
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'PRODUCT_PROMO.MAX_NO_USAGE' | translate }}
			</p>

			<mat-form-field class="w-full relative" appearance="outline">
				<mat-label class="text-dark-grey"
					>{{ 'PRODUCT_PROMO.MAX_NO_USAGE' | translate }}
				</mat-label>
				<input
					formControlName="clientUsage"
					class="text-font-16 text-[#4E4B66]"
					type="number"
					matInput
					(wheel)="$event.preventDefault()"
					placeholder="{{ 'PRODUCT_PROMO.MAX_NO_USAGE' | translate }}"
				/>
				<img
					*ngIf="getController('clientUsage')?.value"
					(click)="getController('clientUsage')?.reset()"
					class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
					src="./assets/images/close-square.svg"
					alt=""
				/>
				<mat-error>
					<validation-message
						[controller]="getController('clientUsage')"
						controller_name="PRODUCT_PROMO.MAX_NO_USAGE"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
		</div>
		<!-- CLIENT USAGE  -->
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<!-- AMOUNT -->
		<div>
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'PRODUCT_PROMO.OFFER_AMOUNT' | translate }}
			</p>

			<mat-form-field class="w-full relative" appearance="outline">
				<mat-label class="text-dark-grey"
					>{{ 'PRODUCT_PROMO.OFFER_AMOUNT' | translate }}
				</mat-label>
				<input
					formControlName="Amount"
					class="text-font-16 text-[#4E4B66]"
					type="number"
					(wheel)="$event.preventDefault()"
					min="1"
					matInput
					placeholder="{{ 'PRODUCT_PROMO.OFFER_AMOUNT' | translate }}"
				/>
				<img
					*ngIf="getController('Amount')?.value"
					(click)="getController('Amount')?.reset()"
					class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
					src="./assets/images/close-square.svg"
					alt=""
				/>
				<mat-error>
					<validation-message
						[controller]="getController('Amount')"
						controller_name="PRODUCT_PROMO.OFFER_AMOUNT"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<div>
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'GENERAL_LABELS.STATUS' | translate }}
			</p>
			<div class="flex flex-col">
				<mat-checkbox
					[checked]="
						this.getController('ActivationStatus').value?.includes(
							status?.value
						)
					"
					[value]="status.value"
					(change)="CheckboxChange($event, 'ActivationStatus')"
					*ngFor="let status of activationEnum"
					>{{ 'ACTIONS.' + status?.name | translate }}</mat-checkbox
				>
			</div>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<div>
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'PRODUCT_PROMO.OFFER_TYPE' | translate }}
			</p>
			<div class="flex flex-col">
				<mat-checkbox
					[checked]="
						this.getController('promocodeTypes').value?.includes(type.value)
					"
					[value]="type.value"
					(change)="CheckboxChange($event, 'promocodeTypes')"
					*ngFor="let type of promoCodeTypesEnum"
					>{{ 'PRODUCT_PROMO.' + type?.name | translate }}</mat-checkbox
				>
			</div>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<div class="pb-46px">
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'PRODUCT_PROMO.LABELING' | translate }}
			</p>
			<div class="flex flex-col">
				<mat-checkbox
					[checked]="this.filterData.LabelStatus?.includes(label.value)"
					[value]="label.value"
					(change)="CheckboxChange($event, 'LabelStatus')"
					*ngFor="let label of labelingEnum"
					>{{ 'PRODUCT_PROMO.' + label.name | translate }}</mat-checkbox
				>
			</div>
		</div>

		<button
			[disabled]="
				filterCount == 0 ||
				(getController('endDate').value < getController('startDate').value &&
					getController('endDate').value) ||
				this.filterForm.invalid
			"
			class="bg-gradient text-white w-[89%] p-0 absolute bottom-5"
			mat-button
			(click)="submit()"
		>
			{{ 'ACTIONS.APPLY_FILTER' | translate }}
		</button>
	</div>
</div>
